/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Cost_TitleInputs */

const en_mk_sol_cost_title = /** @type {(inputs: Mk_Sol_Cost_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it would cost`)
};

const id_mk_sol_cost_title = /** @type {(inputs: Mk_Sol_Cost_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perkiraan biaya`)
};

/**
* | output |
* | --- |
* | "What it would cost" |
*
* @param {Mk_Sol_Cost_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_cost_title = /** @type {((inputs?: Mk_Sol_Cost_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Cost_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_cost_title(inputs)
	return en_mk_sol_cost_title(inputs)
});